// The map Geolocation variant. Markup is shared with the no-map variant — see GeolocationTemplates.js.
const { buildGeolocationTemplates } = require('./GeolocationTemplates.js');

module.exports = buildGeolocationTemplates('GeolocationSelectorWithMap');
